import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BusStopAppEntityBusStopWrite } from '../../../../../../../openapi';

@Injectable()
export class BusStopItemForm extends AppForm {
  constructor() {
    super({
      roadNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      roadSide: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      stopName: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      stopNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      location: new FormControl(null, [Validators.required, Validators.maxLength(255)])
    });
  }

  public get roadNumber(): FormControl {
    return this.get('roadNumber') as FormControl;
  }

  public get roadName(): FormControl {
    return this.get('roadName') as FormControl;
  }

  public get roadSide(): FormControl {
    return this.get('roadSide') as FormControl;
  }

  public get stopNumber(): FormControl {
    return this.get('stopNumber') as FormControl;
  }

  public get stopName(): FormControl {
    return this.get('stopName') as FormControl;
  }

  public get location(): FormControl {
    return this.get('location') as FormControl;
  }

  public get values(): BusStopAppEntityBusStopWrite {
    return {
      ...this.value,
      roadNumber: `${this.roadNumber.value || ''}`,
      roadSide: `${this.roadSide.value || ''}`,
      stopNumber: `${this.stopNumber.value || ''}`,
      stopName: `${this.stopName.value || ''}`,
      location: `${this.location.value || ''}`
    };
  }

}
